export default {
  refundSources: {
    100: '车主端',
    200: '能源平台',
    300: 'SP客服',
    400: 'OSP后台',
    500: '订单系统',
    600: '财务系统',
  },
  itemType: {
    2: '单品',
    3: '套餐',
  },
  payStates: {
    701: '待支付',
    702: '已支付',
    703: '支付失败',
    704: '支付取消',
  },
  refundStates: {
    301: '退款中',
    302: '退款成功',
    303: '退款失败',
  },
  refundTypes: {
    100: '全部退款',
    101: '部分退款',
    102: '调账',
    103: '补差价',
  },
  examStates: {
    100: '审核中',
    200: '已同意',
    300: '已拒绝',
  },
  payChannels: {
    1: '微信支付',
    2: '支付宝',
    3: '银联云闪付',
    4: '数字人民币',
    111: '车队支付',
  },
  orderOrigin: {
    1000: '车主端',
    2000: '维保线上化',
    3000: '车队商城',
  },
  orderType: {
    10: 'ToC订单(车队用户)-司机付',
    11: 'ToB订单-车务付',
    20: 'ToC订单-司机付',
  },
  orderState: {
    1000: '待支付',
    2000: '待发货',
    3000: '待收货',
    4000: '待使用',
    5000: '维修中',
    6000: '已完成',
    8000: '已取消',
  },
  businessTypes: {
    300: '维修保养',
  },
  remark: {
    0: '不想要了',
    1: '商品错选/多选',
    2: '商品无货',
    3: '商品降价',
    4: '价格高于其他平台',
    5: '没用/少用/错用优惠',
    6: '其他',
  },
  migrateOrNot: {
    0: '否',
    1: '是',
  },
  userTypes: {
    11: '车队用户',
    10: '车队用户',
    20: '个人用户',
    30: 'B端商城',
  },
}
